module.exports = __webpack_public_path__ + "img/loading.efce102d.svg";